import { clsx } from 'clsx'

import { E2E_ERROR } from 'Constants/e2e'

import type { FeedbackTextProps } from './FeedbackText.types'

export const FeedbackText = (props: FeedbackTextProps) => {
  const { children, className, isInvalid, isSuccess, ...restProps } = props

  const classNames = clsx(
    'FeedbackText',
    isInvalid && 'FeedbackText-invalid',
    isSuccess && 'FeedbackText-success',
    className,
  )

  return (
    <span
      className={classNames}
      data-e2e={isInvalid && E2E_ERROR}
      {...restProps}
      role="alert"
    >
      {children}
    </span>
  )
}
